import React from "react"
import style from "./video-embed.mod.scss"
import PropTypes from "prop-types"

const getEmbedUrl = ({ provider, providerUid, url }) => {
  switch (provider) {
    case "youtube":
      return `https://www.youtube.com/embed/${providerUid}?rel=0`
    case "vimeo":
      return `https://player.vimeo.com/video/${providerUid}`
    case "facebook":
      return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
        url
      )}`
    default:
      return url
  }
}

const VideoEmbed = ({ video, title }) => {
  if (!video) return null

  return (
    <div className={style["video-embed"]}>
      <div className={style["video-embed__wrapper"]}>
        <iframe
          className={style["video-embed__iframe"]}
          src={getEmbedUrl(video)}
          title={title || video.title}
          frameBorder="0"
          referrerPolicy="strict-origin-when-cross-origin"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  )
}

VideoEmbed.propTypes = {
  video: PropTypes.shape({
    url: PropTypes.string,
    provider: PropTypes.string,
    providerUid: PropTypes.string,
    title: PropTypes.string
  }),
  title: PropTypes.string
}

export default VideoEmbed
